/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type GenericValidationError,
    GenericValidationErrorFromJSON,
    GenericValidationErrorToJSON,
} from '../models/GenericValidationError';
import {
    type NotFoundResult,
    NotFoundResultFromJSON,
    NotFoundResultToJSON,
} from '../models/NotFoundResult';
import {
    type TranslationResponsePagedResult,
    TranslationResponsePagedResultFromJSON,
    TranslationResponsePagedResultToJSON,
} from '../models/TranslationResponsePagedResult';
import {
    type TranslationUpdateRequest,
    TranslationUpdateRequestFromJSON,
    TranslationUpdateRequestToJSON,
} from '../models/TranslationUpdateRequest';
import {
    type TranslationsSearchRequest,
    TranslationsSearchRequestFromJSON,
    TranslationsSearchRequestToJSON,
} from '../models/TranslationsSearchRequest';

export interface ApiTranslationsEditPutRequest {
    translationUpdateRequest: TranslationUpdateRequest;
}

export interface ApiTranslationsSearchPostRequest {
    translationsSearchRequest: TranslationsSearchRequest;
}

/**
 * 
 */
export class TranslationsApi extends runtime.BaseAPI {

    /**
     * Creates request options for apiTranslationsEditPut without sending the request
     */
    async apiTranslationsEditPutRequestOpts(requestParameters: ApiTranslationsEditPutRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['translationUpdateRequest'] == null) {
            throw new runtime.RequiredError(
                'translationUpdateRequest',
                'Required parameter "translationUpdateRequest" was null or undefined when calling apiTranslationsEditPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/translations/edit`;

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: TranslationUpdateRequestToJSON(requestParameters['translationUpdateRequest']),
        };
    }

    /**
     */
    async apiTranslationsEditPutRaw(requestParameters: ApiTranslationsEditPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.apiTranslationsEditPutRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiTranslationsEditPut(requestParameters: ApiTranslationsEditPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiTranslationsEditPutRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for apiTranslationsSearchPost without sending the request
     */
    async apiTranslationsSearchPostRequestOpts(requestParameters: ApiTranslationsSearchPostRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['translationsSearchRequest'] == null) {
            throw new runtime.RequiredError(
                'translationsSearchRequest',
                'Required parameter "translationsSearchRequest" was null or undefined when calling apiTranslationsSearchPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/translations/search`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TranslationsSearchRequestToJSON(requestParameters['translationsSearchRequest']),
        };
    }

    /**
     */
    async apiTranslationsSearchPostRaw(requestParameters: ApiTranslationsSearchPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TranslationResponsePagedResult>> {
        const requestOptions = await this.apiTranslationsSearchPostRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TranslationResponsePagedResultFromJSON(jsonValue));
    }

    /**
     */
    async apiTranslationsSearchPost(requestParameters: ApiTranslationsSearchPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TranslationResponsePagedResult> {
        const response = await this.apiTranslationsSearchPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
